import React, { useEffect, useState } from 'react';
import MkBtn from './MkBtn';
import bmbIcon from '../../assets/images/mk/mk-bmb-icon-192.webp';
import { BMB_IOS_URL, bmbPlayHref, kmoPlayHref } from '../../marketing/links';
import { mkTrack } from '../../marketing/track';

const kmoLogo = require('../../assets/images/logo-icon.svg').default;

function resolve(page, platform) {
  if (page === 'home') {
    if (platform === 'ios') {
      return {
        app: 'bmb',
        name: 'Bring Me Back',
        sub: 'For iPhone · Free to download',
        label: 'Get Bring Me Back',
        href: BMB_IOS_URL,
        event: 'bmb:appstore:home',
      };
    }
    return {
      app: 'kmo',
      name: 'Keep Me Out',
      sub: 'Free to download · Android',
      label: 'Get Keep Me Out',
      href: kmoPlayHref('home_sticky'),
      event: 'kmo:play:home',
    };
  }
  if (platform === 'android') {
    return {
      app: 'bmb',
      name: 'Bring Me Back',
      sub: 'Free to download · Google Play',
      label: 'Get Bring Me Back',
      href: bmbPlayHref('bmb_sticky'),
      event: 'bmb:play:bmb',
    };
  }
  if (platform === 'ios') {
    return {
      app: 'bmb',
      name: 'Bring Me Back',
      sub: 'Free to download · App Store',
      label: 'Get Bring Me Back',
      href: BMB_IOS_URL,
      event: 'bmb:appstore:bmb',
    };
  }
  return {
    app: 'bmb',
    name: 'Bring Me Back',
    sub: 'iPhone and Android',
    label: 'Download options',
    href: '#get',
    event: 'bmb:anchor:bmb',
  };
}

/**
 * Sticky install bar for phones (≤640px, CSS). Shown once the hero CTA has scrolled away and hidden
 * again from the final CTA on; uses the `hidden` attribute while hidden so it is never focusable.
 * Text buttons only — no store logos.
 */
const MkStickyCta = ({ platform, page }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const start = document.getElementById('mk-hero-cta');
    const end = document.getElementById('mk-final-cta');
    if (!start || !end || !('IntersectionObserver' in window)) return undefined;
    let pastStart = false;
    let reachedEnd = false;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.target === start) pastStart = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (e.target === end) reachedEnd = e.isIntersecting || e.boundingClientRect.top < 0;
      });
      setVisible(pastStart && !reachedEnd);
    });
    io.observe(start);
    io.observe(end);
    return () => io.disconnect();
  }, []);

  const cfg = resolve(page, platform);
  return (
    <div className={`mk-sticky mk-sticky--${cfg.app}`} hidden={!visible}>
      <div className="mk-sticky__inner">
        {cfg.app === 'kmo' ? (
          <span className="mk-sticky__icon mk-sticky__icon--kmo">
            <img src={kmoLogo} alt="" width={22} height={22} />
          </span>
        ) : (
          <img className="mk-sticky__icon" src={bmbIcon} alt="" width={36} height={36} loading="lazy" decoding="async" />
        )}
        <span className="mk-sticky__text">
          <span className="mk-sticky__name">{cfg.name}</span>
          <span className="mk-sticky__sub">{cfg.sub}</span>
        </span>
        <MkBtn
          variant={cfg.app}
          size="sm"
          href={cfg.href}
          onClick={() => mkTrack('sticky_cta_click', cfg.event)}
        >
          {cfg.label}
        </MkBtn>
      </div>
    </div>
  );
};

export default MkStickyCta;
